const isAnalyticsAllowed = ['app.mindcloud.co', 'staging.mindcloud.co'].some((domain) => window?.location?.hostname?.includes(domain));

export default isAnalyticsAllowed;
